var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cny-banner",style:(_vm.myStyle)},[_c('div',{staticClass:"content",style:(_vm.contentStyle)},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.date)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }